import { Link, useLocation, useParams } from 'react-router-dom';
import { useSidebar } from '@/core/hooks/useSidebar';
import { secondaryNavItems } from '@/shared/config/sidebar.config';
import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';

export function SidebarSecondaryNav() {
  const { t } = useTranslation('layout');
  const { orgId } = useParams<{ orgId: string }>();
  const { pathname } = useLocation();
  const { closeMobile, isMobile } = useSidebar();

  return (
    <div className="px-3 py-2">
      <nav className="flex flex-col gap-0.5">
        {secondaryNavItems.map(({ id, icon: Icon, href }) => {
          const isActive = pathname.startsWith(`/${orgId}/${href}`);
          return (
            <Link
              key={id}
              to={`/${orgId}/${href}`}
              onClick={() => isMobile && closeMobile()}
              className={cn(
                'flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors',
                isActive
                  ? 'bg-primary/10 text-primary font-medium'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground',
              )}
            >
              <Icon className="w-4 h-4 shrink-0" />
              {t(`sidebar.secondary.${id}`)}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
